import React, { Component } from "react";
import { LocalizationContext } from "localization-context";

const WithContext = (Component) => {
  return (props) => (
    <LocalizationContext.Consumer>
      {(value) => <Component {...props} localizationContext={value} />}
    </LocalizationContext.Consumer>
  );
};

class NoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderNoCardContainder() {
    let noCardContainer = [];
    let contentInfo = [
      {
        key: "line1",
        rowStyle: { marginTop: "30px" },
        rowItems: [
          {
            itemClassName: "nocard-example-wrapper-small alexa-color-cardblue",
            itemDecorationClassName: "nocard-example-decoration-blue",
            itemText: this.props.localizationContext.someThingToTryDetail1,
            itemTextClassName: "nocard-example-content",
          },
          {
            itemClassName: "nocard-example-wrapper-small alexa-color-cardblue",
            itemDecorationClassName: "nocard-example-decoration-blue",
            itemText: this.props.localizationContext.someThingToTryDetail2,
            itemTextClassName: "nocard-example-content",
          },
          {
            itemClassName: "nocard-example-wrapper-small alexa-color-cardblue",
            itemDecorationClassName: "nocard-example-decoration-blue",
            itemText: this.props.localizationContext.someThingToTryDetail3,
            itemTextClassName: "nocard-example-content",
          },
        ],
      },
      {
        key: "line2",
        rowStyle: { marginTop: "50px" },
        rowItems: [
          {
            itemClassName: "nocard-example-wrapper alexa-color-green",
            itemDecorationClassName: "nocard-example-decoration-green",
            itemText: this.props.localizationContext.someThingToTryDetail5,
            itemTextClassName: "nocard-example-content-black",
          },
          {
            itemClassName: "nocard-example-wrapper alexa-color-green",
            itemDecorationClassName: "nocard-example-decoration-green",
            itemText: this.props.localizationContext.someThingToTryDetail6,
            itemTextClassName: "nocard-example-content-black",
          },
          {
            itemClassName: "nocard-example-wrapper alexa-color-green",
            itemDecorationClassName: "nocard-example-decoration-green",
            itemText: this.props.localizationContext.someThingToTryDetail7,
            itemTextClassName: "nocard-example-content-black",
          },
        ],
      },
    ];

    contentInfo.map((item, index) => {
      let subItems = [];
      item.rowItems.map((it, idx) => {
        let subItem = (
          <div key={idx} className={it.itemClassName}>
            <div className={it.itemDecorationClassName}></div>
            <div className={it.itemTextClassName}>
              <p>{it.itemText}</p>
            </div>
          </div>
        );
        subItems.push(subItem);
      });
      let wrapper = (
        <div
          key={index}
          className="alexa-flex-row-center-jcenter"
          style={item.rowStyle}
        >
          {subItems}
        </div>
      );
      noCardContainer.push(wrapper);
      return item;
    });
    return noCardContainer;
  }

  render() {
    let noCardContent = this.renderNoCardContainder();
    return (
      <LocalizationContext.Consumer>
        {(values) => (
          <div className="alexa-flex-column-center nocard-container">
            <div className="aleax-absolute-vertical-center nocard-wrapper">
              <div className="nocard-description">
                {/* <p>{values.canUseAlexa} Whenever you're ready,click on the</p>
                                <p>Alexa button located just beside your avatar to ask questions or</p>
                                <p>give commands.You may also use the default shortcut</p>
                                <p>Ctrl+Shift+A to activate Alexa.</p> */}
                <div
                  className="nocard-description-text-wrapper"
                  style={{
                    width: "437px",
                    margin: "0 auto",
                    lineHeight: "25px",
                  }}
                >
                  {values.canUseAlexa}
                  {values.wheneverCommands}
                  {values.canUseAlexaHotkeyToActivate}
                </div>
                <br></br>
              </div>
              {noCardContent}
              {/* <div className="alexa-flex-row-center-jcenter" style={{marginTop:'30px'}}>
                                <div className="nocard-example-wrapper-small alexa-color-cardblue">
                                    <div className="nocard-example-decoration-blue"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                                <div className="nocard-example-wrapper-small alexa-color-cardblue">
                                    <div className="nocard-example-decoration-blue"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                                <div className="nocard-example-wrapper-small alexa-color-cardblue">
                                    <div className="nocard-example-decoration-blue"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="alexa-flex-row-center-jcenter" style={{marginTop:'50px'}}>
                                <div className="nocard-example-wrapper-small alexa-color-green">
                                    <div className="nocard-example-decoration-green"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                                <div className="nocard-example-wrapper-small alexa-color-green">
                                    <div className="nocard-example-decoration-green"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                                <div className="nocard-example-wrapper-small alexa-color-green">
                                    <div className="nocard-example-decoration-green"></div>
                                    <div className="nocard-example-content">
                                        <p>{values.someThingToTryDetail1}</p>
                                    </div>
                                </div>
                            </div> */}
            </div>
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
}

export default WithContext(NoCard);
